import { FiltrosProducto, Producto } from '../../model/producto/producto';

/**
 * Puerto abstracto: ProductoRepository.
 *
 * Define el contrato para búsqueda de productos.
 * Implementado por HttpProductoRepository en infraestructura.
 *
 * @author Sura - Migración GWT a Angular
 */
export abstract class ProductoRepository {

  /**
   * Busca productos con filtros y paginación.
   *
   * @param filtros Parámetros de búsqueda
   * @returns Lista paginada de productos
   */
  abstract buscarProductos(filtros: FiltrosProducto): Promise<Producto[]>;

  /**
   * Cuenta el total de productos que cumplen los filtros.
   *
   * @param filtros Parámetros de búsqueda
   * @returns Total de registros
   */
  abstract contarProductos(filtros: FiltrosProducto): Promise<number>;
}
